import React from "react";

const Gym = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M9.40039 6C9.40039 6.79565 9.71646 7.55871 10.2791 8.12132C10.8417 8.68393 11.6047 9 12.4004 9C13.196 9 13.9591 8.68393 14.5217 8.12132C15.0843 7.55871 15.4004 6.79565 15.4004 6C15.4004 5.20435 15.0843 4.44129 14.5217 3.87868C13.9591 3.31607 13.196 3 12.4004 3C11.6047 3 10.8417 3.31607 10.2791 3.87868C9.71646 4.44129 9.40039 5.20435 9.40039 6Z"
        stroke="#00A3BC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.23578 9H17.5658C17.8 8.99996 18.0268 9.08213 18.2066 9.23216C18.3864 9.3822 18.5079 9.59059 18.5498 9.821L20.1868 18.821C20.213 18.9651 20.2072 19.1133 20.1699 19.2549C20.1326 19.3966 20.0645 19.5283 19.9707 19.6408C19.8768 19.7532 19.7594 19.8437 19.6267 19.9058C19.494 19.9679 19.3493 20 19.2028 20H5.59878C5.45229 20 5.30758 19.9679 5.17489 19.9058C5.04219 19.8437 4.92476 19.7532 4.83089 19.6408C4.73702 19.5283 4.66901 19.3966 4.63167 19.2549C4.59433 19.1133 4.58856 18.9651 4.61478 18.821L6.25178 9.821C6.2937 9.59059 6.41517 9.3822 6.59499 9.23216C6.77481 9.08213 7.00159 8.99996 7.23578 9Z"
        stroke="#00A3BC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Gym;
